import { jsx as i, jsxs as S, Fragment as I } from "react/jsx-runtime";
import k, { useState as E, useId as T, useEffect as F, cloneElement as q } from "react";
import { c as h } from "../clsx-OuTLNxxd.js";
import { A as w, E as R } from "../index-_mwUc74W.js";
import '../Accordion.css';const U = "320px", L = "600px", O = "1025px", D = "_header_1fjuv_33", G = "_splitHeader_1fjuv_37", J = "_iconSlot_1fjuv_43", K = "_heading_1fjuv_50", Q = "_toggle_1fjuv_57", X = "_triggerElement_1fjuv_66", Y = "_indicator_1fjuv_72", Z = "_trigger_1fjuv_66", M = "_contentElement_1fjuv_112", V = "_content_1fjuv_112", C = "_primary_1fjuv_132", N = "_secondary_1fjuv_135", ee = "_item_1fjuv_141", te = "_dense_1fjuv_141", ne = "_nav_1fjuv_234", ie = "_link_1fjuv_239", oe = "_headingText_1fjuv_271", ce = "_linkLabel_1fjuv_272", re = "_linkList_1fjuv_297", t = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: U,
  "mobile-wide": "480px",
  tablet: L,
  "tablet-wide": "800px",
  desktop: O,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  header: D,
  splitHeader: G,
  iconSlot: J,
  heading: K,
  toggle: Q,
  triggerElement: X,
  indicator: Y,
  trigger: Z,
  contentElement: M,
  content: V,
  primary: C,
  secondary: N,
  item: ee,
  dense: te,
  nav: ne,
  link: ie,
  headingText: oe,
  linkLabel: ce,
  linkList: re
}, le = (d) => {
  if (typeof requestAnimationFrame != "function")
    return d(), () => {
    };
  let x = 0;
  const c = requestAnimationFrame(() => {
    x = requestAnimationFrame(d);
  });
  return () => {
    cancelAnimationFrame(c), cancelAnimationFrame(x);
  };
}, de = ({
  animationDurationMs: d = 0,
  indicatorSize: x = "xsm",
  isOpen: c,
  isPanelLandmark: e = !0,
  onChange: g,
  stroke: j = "bold"
}) => {
  const [n, y] = E(c), s = d > 0, [m, _] = E(c), [p, a] = E(!!c), b = T(), f = T(), H = () => {
    g == null || g(!n), y(!n);
  };
  F(() => {
    c !== n && y(c);
  }, [c]), F(() => {
    if (!s) return;
    if (n)
      return _(!0), le(() => a(!0));
    a(!1);
    const r = setTimeout(() => _(!1), d);
    return () => clearTimeout(r);
  }, [n, s, d]);
  const u = {
    "aria-controls": f,
    // The watermark travels with the hook, not just with `Accordion.Item`. A caller that drives the
    // disclosure headlessly renders cxy's behaviour on markup of its own — the footer nav does — and
    // without this it is indistinguishable in the DOM from a hand-rolled toggle, which is the one
    // question `data-cxy-name` exists to answer.
    "data-cxy-name": "accordion",
    "aria-expanded": n,
    "data-state": n ? "open" : "closed",
    id: b,
    onClick: H
  }, o = {
    "aria-labelledby": b,
    className: t.contentElement,
    hidden: s ? !m : !n,
    id: f,
    ...e ? { role: "region" } : {},
    ...s ? { "data-animated": "" } : {},
    ...s && p ? { "data-enter": "" } : {}
  };
  return {
    headingProps: u,
    sectionProps: o,
    triggerClass: t.triggerElement,
    Indicator: () => j === "bold" ? /* @__PURE__ */ i(w, { className: t.indicator, size: x }) : /* @__PURE__ */ i(R, { className: t.indicator, size: x })
  };
}, ye = 300, xe = ({
  animationDurationMs: d = 0,
  chevronStroke: x = "bold",
  children: c,
  classNames: e,
  heading: g,
  headingAs: j = "h3",
  icon: n,
  indicator: y,
  indicatorSize: s = "xsm",
  isDense: m = !1,
  isOpen: _ = !1,
  isPanelLandmark: p = !0,
  links: a,
  onChange: b,
  onLinkClick: f,
  testId: H,
  toggleLabel: u,
  trackingAttribute: o,
  variant: r
}) => {
  const { Indicator: l, headingProps: z, sectionProps: W, triggerClass: A } = de({
    animationDurationMs: d,
    isOpen: _,
    isPanelLandmark: p,
    onChange: b,
    indicatorSize: s,
    stroke: x
  }), B = {
    ...z,
    ...o ? { "data-analytics": o } : {},
    ...H ? { "data-testid": H } : {},
    type: "button"
  }, { id: P, ...$ } = B;
  return /* @__PURE__ */ S(
    "div",
    {
      className: h(
        t.item,
        { [t.dense]: m },
        r && r !== "bare" && t[r],
        e == null ? void 0 : e.wrapper
      ),
      "data-cxy-name": "accordion",
      children: [
        /* @__PURE__ */ i(j, { className: h(t.header, { [t.splitHeader]: u }, e == null ? void 0 : e.header), children: u ? /* @__PURE__ */ S(I, { children: [
          /* @__PURE__ */ S("span", { className: h(t.heading, e == null ? void 0 : e.heading), id: P, children: [
            n !== void 0 && /* @__PURE__ */ i("span", { className: t.iconSlot, children: n }),
            g
          ] }),
          /* @__PURE__ */ i(
            "button",
            {
              "aria-label": u,
              className: h(A, t.toggle, e == null ? void 0 : e.button),
              ...$,
              children: y ?? /* @__PURE__ */ i(l, {})
            }
          )
        ] }) : /* @__PURE__ */ S("button", { className: h(A, t.trigger, e == null ? void 0 : e.button), ...B, children: [
          n === void 0 ? g : /* @__PURE__ */ S(I, { children: [
            /* @__PURE__ */ i("span", { className: t.iconSlot, children: n }),
            /* @__PURE__ */ i("span", { className: h(t.headingText, e == null ? void 0 : e.heading), children: g })
          ] }),
          y ?? /* @__PURE__ */ i(l, {})
        ] }) }),
        /* @__PURE__ */ i(
          "div",
          {
            ...W,
            className: h(t.content, e == null ? void 0 : e.content),
            style: { "--cxy-accordion-duration": `${d}ms` },
            children: a ? /* @__PURE__ */ i("ul", { className: t.linkList, children: a.map((v) => /* @__PURE__ */ i("li", { children: /* @__PURE__ */ S("a", { className: t.link, href: v.href, onClick: () => f == null ? void 0 : f(v), children: [
              /* @__PURE__ */ i("span", { className: t.iconSlot, children: v.icon }),
              /* @__PURE__ */ i("span", { className: t.linkLabel, children: v.label })
            ] }) }, `${v.href}-${v.label}`)) }) : c
          }
        )
      ]
    }
  );
}, se = ({
  chevronStroke: d = "bold",
  children: x,
  defaultOpen: c,
  indicatorSize: e = "xsm",
  isDense: g = !1,
  name: j,
  onValueChange: n,
  type: y = "single",
  value: s,
  variant: m = "primary"
}) => {
  const _ = y === "multiple", p = s !== void 0, a = k.Children.toArray(x), b = c ? a.map(() => !0) : a.map((o) => !!o.props.isOpen), [f, H] = E(b), u = (o, r) => {
    let l = [];
    _ ? (l = [...f], l[r] = o) : (l = a.map(() => !1), o === !0 && (l[r] = !0)), H(l);
  };
  return /* @__PURE__ */ i(
    "div",
    {
      className: h(t.accordion, m !== "bare" && t[m]),
      "data-cxy-name": "accordion",
      "data-testid": "accordion-component",
      children: x && a.map(
        (o, r) => (
          // Cloned rather than rebuilt from named props: every prop the item declares reaches it,
          // so adding one to `AccordionItemProps` does not also require adding it here.
          q(o, {
            chevronStroke: d,
            indicatorSize: e,
            isDense: g,
            variant: m,
            isOpen: p ? o.props.value === s : f[r],
            key: `${j}-item-${r}`,
            onChange: (l) => {
              var z, W;
              (W = (z = o.props).onChange) == null || W.call(z, l), p ? n == null || n(l ? o.props.value ?? null : null) : u(l, r);
            }
          })
        )
      )
    }
  );
};
se.Item = xe;
export {
  ye as ACCORDION_FADE_DURATION_MS,
  se as Accordion,
  de as useToggle
};
